import { usePage, router } from "@inertiajs/react"
import { ChevronDown, RotateCcw, User } from "lucide-react"
import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { BRAND_GRADIENT_CLASS } from "@/lib/color-constants"
import { Badge } from "@/components/ui/badge"
import type { SharedData } from "@/types"

export function AppHeader() {
  const { auth } = usePage<SharedData>().props
  const isAssuming = auth.impersonation?.active
  const originalUser = auth.impersonation?.original_user
  const isPublicDemo = auth.user?.demo && !originalUser

  const handleStopAssuming = () => {
    router.post("/users/stop_assuming")
  }
  // const today = new Intl.DateTimeFormat("en-US", {
  //   month: "long",
  //   day: "numeric",
  //   year: "numeric",
  // }).format(new Date())

  return (
    <header className="bg-background/65 dark:bg-background/40 sticky top-0 z-10 border-b border-white/50 px-5 py-4 backdrop-blur-xl lg:px-8 dark:border-white/8">
      <div className="flex flex-col gap-4">
        {isAssuming || isPublicDemo ? (
          <div className="border-border/70 bg-card/85 flex flex-col gap-3 rounded-2xl border px-4 py-3 shadow-sm md:flex-row md:items-center md:justify-between">
            <div className="min-w-0">
              <div className="flex items-center gap-2">
                <Badge variant="secondary" className="rounded-full">
                  {isPublicDemo ? "Demo account" : "Assumed account"}
                </Badge>
                <p className="text-sm font-medium">
                  You&apos;re viewing as {auth.user?.name}
                </p>
              </div>
              <p className="text-muted-foreground mt-1 text-sm">
                {originalUser
                  ? `Return to ${originalUser.name} whenever you're done.`
                  : "Explore the sample data, then sign out when you're done."}
              </p>
            </div>
            {originalUser ? (
              <Button
                variant="outline"
                className="shrink-0 rounded-full"
                onClick={handleStopAssuming}
              >
                <RotateCcw className="mr-2 h-4 w-4" />
                Back to {originalUser.name}
              </Button>
            ) : (
              <Button
                variant="outline"
                className="shrink-0 rounded-full"
                onClick={() => router.delete(`/sessions/${auth.session.id}`)}
              >
                Sign out
              </Button>
            )}
          </div>
        ) : null}

        <div className="flex items-center justify-between gap-4">
          <div className="min-w-0">
            <p className="text-muted-foreground text-sm">Welcome back,</p>
            <h2 className="truncate text-xl font-semibold tracking-tight lg:text-2xl">
              {auth.user?.name}
            </h2>
          </div>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button
                variant="ghost"
                className="border-border/70 bg-card/80 hover:bg-card h-11 rounded-full border px-2.5 shadow-sm backdrop-blur"
              >
                <span
                  className={`flex h-7 w-7 items-center justify-center rounded-full ${BRAND_GRADIENT_CLASS} text-white`}
                >
                  <User className="h-4 w-4" />
                </span>
                <span className="mx-2 hidden text-sm font-medium md:inline">
                  {auth.user?.email}
                </span>
                <ChevronDown className="text-muted-foreground h-4 w-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              className="w-64 rounded-2xl"
              align="end"
              forceMount
            >
              <DropdownMenuItem asChild>
                <a href="/settings/profile">Profile</a>
              </DropdownMenuItem>
              {isAssuming ? (
                <DropdownMenuItem asChild>
                  <button
                    onClick={handleStopAssuming}
                    className="w-full text-left"
                  >
                    Back to {originalUser?.name ?? "my account"}
                  </button>
                </DropdownMenuItem>
              ) : null}
              <DropdownMenuItem asChild>
                <button
                  onClick={() => router.delete(`/sessions/${auth.session.id}`)}
                  className="w-full text-left"
                >
                  Sign out
                </button>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>

        {/* <div className="hidden items-center gap-3 md:flex">
          <div className="border-border/70 bg-card/80 text-muted-foreground flex items-center gap-2 rounded-full border px-4 py-2 text-sm shadow-sm backdrop-blur">
            <CalendarDays className="h-4 w-4" />
            {today}
          </div>
        </div> */}
      </div>

      {/* <div className="mt-4 flex items-center justify-end">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              className="border-border/70 bg-card/80 hover:bg-card h-11 rounded-full border px-2.5 shadow-sm backdrop-blur"
            >
              <span className={`flex h-7 w-7 items-center justify-center rounded-full ${BRAND_GRADIENT_CLASS} text-white`}>
                <User className="h-4 w-4" />
              </span>
              <span className="mx-2 hidden text-sm font-medium md:inline">
                {auth.user?.email}
              </span>
              <ChevronDown className="text-muted-foreground h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-64 rounded-2xl"
            align="end"
            forceMount
          >
            <DropdownMenuItem asChild>
              <a href="/settings/profile">Profile</a>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <button
                onClick={() => router.delete(`/sessions/${auth.session.id}`)}
                className="w-full text-left"
              >
                Sign out
              </button>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div> */}
    </header>
  )
}
